import React from 'react';
import { NavLink } from 'react-router-dom';
import UserLayout from '../../components/user-layout/UserLayout';

import styles from './supportPage.module.scss';

const SupportPage = () => {
  return (
    <UserLayout>
      <section className={styles.supportWrapper}>
        <h1 className={styles.supportWrapper_heading}>Support</h1>

        <section className={styles.selectionWrapper}>
          <NavLink className={styles.cardLink} to="/support/ticket">
            <div className={styles.selectionCard}>
              <div className={styles.imageWrapper}>
                <img
                  className={styles.imageWrapper_img}
                  src={require('../../assets/images/support-icon.png')}
                  alt=""
                />
              </div>
              <h3 className={styles.selectionCard_heading}>Send a ticket</h3>
              <p className={styles.selectionCard_body}>
                Didn't find the answer in the FAQ? Send us a ticket
              </p>
            </div>
          </NavLink>

          <NavLink className={styles.cardLink} to="/support/faq">
            <div className={styles.selectionCard}>
              <div className={styles.imageWrapper}>
                <img
                  className={styles.imageWrapper_img}
                  src={require('../../assets/images/faq.png')}
                  alt=""
                />
              </div>
              <h3 className={styles.selectionCard_heading}>Read our FAQ</h3>
              <p className={styles.selectionCard_body}>
                Learn the fundamentals of getting started with Jobal
              </p>
            </div>
          </NavLink>
        </section>
        {/* <form className={styles.supportForm} action="">
            <div className={styles.formGroup}>
                <label htmlFor=""></label>
                <select name="" id="">
                    <option value=""></option>
                </select>
            </div>
        </form> */}
      </section>
    </UserLayout>
  );
};

export default SupportPage;
